import CatalogTypes from './catalogTypes'

class RasterLayersFinder {
	static fromCatalog(catalog, layers) {
		if (!layers)
			layers = [];
		if (!catalog.children)
			return layers;
		catalog.children.forEach((c) => {
			
			if (c.type === CatalogTypes.LAYER && !layers.find(layer=>layer.name === c.name)) {
				layers.push(c);
			}
			RasterLayersFinder.fromCatalog(c, layers);
		});
		return layers;
	}
}

export default RasterLayersFinder;